function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Box, Button, Collapsible, Text } from 'grommet';
import { FormDown } from 'grommet-icons/icons/FormDown';
import { FormNext } from 'grommet-icons/icons/FormNext';
import { Share } from 'grommet-icons';
import styled, { withTheme } from 'styled-components';

// Core Imports
import Tooltip from 'granite-admin/core/components/Tooltip';
const TooltipWrapper = ({
  children,
  isCollapsed,
  content
}) => {
  if (isCollapsed) return /*#__PURE__*/React.createElement(Tooltip, {
    content: content
  }, children);else return children;
};
const StyledSpan = styled.span`
  svg {
    fill: ${({
  isActive,
  theme
}) => isActive ? theme.global.colors['sidebar-svg-active'] + `!important` : theme.global.colors['sidebar-svg'] + `!important`};
  }
`;
const StyledText = styled(Text)`
  color: ${({
  isActive,
  hoverIndicator,
  theme
}) => isActive ? theme.global.colors['sidebar-label-active'] : theme.global.colors['sidebar-label']};
  font-weight: ${({
  theme
}) => theme.global.colors['sidebar-label-bold'] ? theme.global.colors['sidebar-label-bold'] : null};
`;
const StyledBox = styled(Box)`
  &:hover svg {
    fill: ${({
  isActive,
  theme
}) => theme.global.colors['sidebar-svg-hover'] + `!important`};
  }
  &:hover span {
    color: ${({
  isActive,
  theme
}) => theme.global.colors['sidebar-label-hover'] + `!important`};
  }
`;
function isInViewport(el, offsetHeight) {
  const rect = el.getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight - offsetHeight || document.documentElement.clientHeight - offsetHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}
const MenuButton = ({
  children,
  label,
  id,
  icon,
  level,
  isActive,
  activeColor,
  isExpandable,
  isExpanded: defaultIsExpanded,
  hoverIndicatorOptions,
  onClick,
  isCollapsed,
  textColor,
  sideMenuItem,
  pathname,
  openInNewTab,
  theme,
  menuItemHPad,
  offsetHeight,
  ...rest
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultIsExpanded);
  const handleClick = () => {
    setIsExpanded(!isExpanded);
    onClick(!isExpanded);
  };
  useEffect(() => {
    if (isActive) {
      let item = document.getElementById(`${id}`);
      if (item && !isInViewport(item, offsetHeight)) setTimeout(() => item.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      }), 10);
    }
  }, [isActive, id, isCollapsed, offsetHeight]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledBox, {
    id: id,
    direction: "row",
    align: "center",
    justify: "between",
    background: isActive ? activeColor : null,
    margin: {
      vertical: isCollapsed ? 'xsmall' : '0'
    }
  }, /*#__PURE__*/React.createElement(Button, _extends({
    onClick: handleClick,
    as: "div",
    fill: true,
    hoverIndicator: isActive ? false : hoverIndicatorOptions ? hoverIndicatorOptions : true
  }, rest), /*#__PURE__*/React.createElement(TooltipWrapper, {
    content: label,
    isCollapsed: isCollapsed
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "column",
    justify: "between"
  }, /*#__PURE__*/React.createElement(Box, {
    pad: {
      vertical: 'small',
      horizontal: menuItemHPad
    },
    direction: "row",
    justify: isCollapsed ? 'center' : 'between',
    style: {
      marginLeft: !isCollapsed ? `${16 * level}px` : '0px'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    plain: true,
    as: "div",
    style: {
      display: 'flex'
    },
    icon: icon && typeof icon === 'string' ? /*#__PURE__*/React.createElement(StyledSpan, {
      theme: theme,
      isActive: isActive,
      style: {
        display: 'flex'
      },
      dangerouslySetInnerHTML: {
        __html: icon.replaceAll('sidebar-svg', theme?.global?.colors['sidebar-svg'])
      }
    }) : icon,
    label: isCollapsed ? '' : /*#__PURE__*/React.createElement(StyledText, {
      theme: theme,
      isActive: isActive,
      color: textColor
    }, label)
  }), !isCollapsed && isExpandable && /*#__PURE__*/React.createElement(Box, {
    alignSelf: "end"
  }, isExpanded ? /*#__PURE__*/React.createElement(FormDown, {
    size: "20px"
  }) : /*#__PURE__*/React.createElement(FormNext, {
    size: "20px"
  })), sideMenuItem === true && !isExpandable && !isCollapsed && /*#__PURE__*/React.createElement(Box, {
    pad: {
      bottom: '2px',
      top: 'xsmall',
      horizontal: 'xsmall'
    },
    alignSelf: "end",
    round: "xsmall",
    border: {
      color: 'brand',
      size: '1px'
    },
    onClick: e => {
      openInNewTab({
        label,
        pathname: `/${pathname}`
      });
    }
  }, /*#__PURE__*/React.createElement(Share, {
    color: "brand",
    size: "12px"
  }))))))), /*#__PURE__*/React.createElement(Collapsible, {
    open: isExpanded
  }, children));
};
MenuButton.defaultProps = {
  icon: null,
  isActive: false,
  activeColor: 'brand',
  isCollapsed: false,
  isExpandable: false,
  isExpanded: false,
  level: 0,
  onClick: () => {},
  textColor: 'text',
  menuItemHPad: 'medium'
};
MenuButton.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.object]),
  isActive: PropTypes.bool,
  activeColor: PropTypes.string,
  isCollapsed: PropTypes.bool,
  isExpandable: PropTypes.bool,
  isExpanded: PropTypes.bool,
  level: PropTypes.number || PropTypes.string,
  onClick: PropTypes.func,
  textColor: PropTypes.string,
  menuItemHPad: PropTypes.string,
  offsetHeight: PropTypes.number
};
export default withTheme(MenuButton);